<div  class="mainDiv" [ngClass]="indexList!=0 ? 'marginText' : null" (click)="onClickCategory(1)">
    <div class="m-auto"  >
      <div [ngClass]="restaurantCategory==8 ? 'restaurantItemForList' : 'image1'">
        <div [ngClass]="restaurantCategory==8 ? 'forImageFile2' : 'forImageFile'" >
          <img [ngClass]="restaurantCategory==8 ? 'imageFile2' : 'imageFile'"
           [src]="mainRestaurantItem.ImageFile" >  
        
         
        </div>
  
        <div [ngClass]="restaurantCategory==8 ? 'divBottonForList' : 'divBotton'">  
            <div *ngIf="mainRestaurantItem.IsTemporaryClosed == 1"
            [ngClass]="restaurantCategory == 8 ? 'closeMessage closeMessage2' : 'closeMessage '"
            > סגור כרגע להזמנות</div>
          <div [ngClass]="restaurantCategory==8 ? 'headerForList' : 'header'" > 
    <span [ngClass]="restaurantCategory==8 ? 'categoryName' : 'categoryTop2'">{{mainRestaurantItem.Name}}</span>
    <span *ngIf="mainRestaurantItem.Kashrut" [ngClass]="restaurantCategory==8 ? 'kashrutForList' : 'kashrut'">{{mainRestaurantItem.Kashrut}}</span>
  </div>
    <!-- <span class="place">- {{mainRestaurantItem.Category}}</span> -->
    <div  [ngClass]="restaurantCategory==8 ? 'categoryTopDivForList' : 'categoryTopDiv'" >
  <span [ngClass]="restaurantCategory==8 ? 'resTop' :'categoryTop'">{{mainRestaurantItem.Header}}</span>
  </div>
  <div [ngClass]="restaurantCategory==8 ? 'line' :'line36'"></div>

  <div  dir="rtl" class="forDeliveryAndTime" [ngClass]="restaurantCategory==8 ? 'forDeliveryAndTimeRes' : null" >
    <span *ngIf="deliveryPriceText != ''" [ngClass]="restaurantCategory==8 ? 'resTopForDelivery' :'forDeliveryAndTimeText'"> {{deliveryPriceText}}</span>

    <span  [ngClass]="restaurantCategory==8  ? 'resTop' : 'forDeliveryAndTimeText'" >
          <span *ngIf="timeDeliveryText != '' && deliveryPriceText != ''" class="forDeliveryAndTimeTextBetween">•</span>
       {{timeDeliveryText}}</span>

    <span   [ngClass]="restaurantCategory==8 ?'resTop' :'forDeliveryAndTimeText'">
          <span *ngIf="timeDeliveryText != '' && minimumOrderText != ''" class="forDeliveryAndTimeTextBetween">•</span>
       {{minimumOrderText}}</span>
  </div>
    </div>     
  <div >
  </div> 
  </div>
      </div>
  </div>